import {useEffect} from "react";
import {IExhibitorUser} from "@evennt-tech/api-v2-core";
import {shallow} from "zustand/shallow";
import {useCurrentExhibitor} from "store/current-exhibitor/current-exhibitor.store";

export default (): IExhibitorUser | null => {
  const {fetch} = useCurrentExhibitor();

  const currentExhibitor = useCurrentExhibitor(
    (state) => state.getAll()?.user || null,
    shallow
  );

  useEffect(() => {
    fetch();
  }, []);

  return currentExhibitor;
};
